// @ts-nocheck
import { BoxV2 } from 'sonata-react-components';
import styled from 'styled-components';

export const MultiBoxStyled = styled(BoxV2)`
  height: 48px;
  min-width: 148px;
  width: auto;
  .multiDetails {
    &__body {
      background-color: ${props => props.theme.uiColors.boxBgMultiHeaderDark};
      box-sizing: border-box;
      display: flex;
      min-width: 148px;
      width: min-content;
    }
  }
`;
